
import React from "react";

const Subvencio = () => {
  return (
    <div className="subvencio">
      <div className="subvencio-enisa-box">
        <img className="enisa-logo" src="/img/enisa-logo.png" alt="ENISA" loading="lazy" decoding="async" />
      </div>

      <div className="subvencio-main-box">
        <div className="images-container">
          <img src="/img/dep.png" alt="Department" loading="lazy" decoding="async" />
          <img src="/img/fondo.svg" alt="Fondo" loading="lazy" decoding="async" />
        </div>

        <div className="text-subvencio">
          Aquesta actuació està impulsada i subvencionada pel Departament d'Empresa i Treball i cofinançada per la Unió Europea mitjançant el Fons Social Europeu Plus
        </div>
      </div>
    </div>
  );
};

export default Subvencio;
